import { render, staticRenderFns } from "./PdvReverseAuthorizationList.vue?vue&type=template&id=227cdddb"
import script from "./PdvReverseAuthorizationList.vue?vue&type=script&lang=js"
export * from "./PdvReverseAuthorizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports